/* Enhances the existing Shopify picker and form; never changes variant records. */
(() => {
  function initialise(scope) {
    scope.querySelectorAll('[data-cb-purchase-data]').forEach(dataElement => {
      if (dataElement.dataset.ready) return;
      const section = dataElement.closest('.js-product');
      const picker = section && section.querySelector('variant-picker');
      const form = section && section.querySelector('.js-product-form-main');
      if (!picker || !form || !window.CBNaturalPurchaseUtils) return;
      const data = JSON.parse(dataElement.textContent);
      const info = section.querySelector('.product-info');
      const first = info.querySelector('.product-price');
      const last = form.closest('.product-info__block');
      if (!first || !last) return;
      dataElement.dataset.ready = 'true';
      const panel = document.createElement('div');
      panel.className = 'cb-purchase-panel';
      panel.setAttribute('aria-label', 'Choose a pack and buy');
      info.insertBefore(panel, first);
      let node = first;
      while (node) {
        const next = node.nextSibling;
        panel.appendChild(node);
        if (node === last) break;
        node = next;
      }
      const money = cents => new Intl.NumberFormat('en-GB', {style:'currency', currency:data.currency || 'GBP'}).format(cents / 100);
      const unit = (price, count) => money(Math.round(price / count));
      picker.querySelectorAll('.option-selector').forEach(selector => {
        const inputs = [...selector.querySelectorAll('input[type="radio"]')];
        const packInputs = inputs.filter(input => data.variants.some(variant => variant.option === input.value));
        if (!packInputs.length) {
          if (inputs.length === 1) selector.classList.add('cb-purchase-single-option');
          return;
        }
        selector.classList.add('cb-purchase-pack-options');
        selector.querySelector('legend').textContent = 'Choose pack quantity (tubs with lids)';
        packInputs.forEach(input => {
          const variant = data.variants.find(item => item.option === input.value);
          const label = input.nextElementSibling;
          if (!variant.pack || !label) return;
          label.replaceChildren();
          const count = document.createElement('strong');
          count.textContent = variant.pack.toLocaleString('en-GB');
          const price = document.createElement('span');
          price.className = 'cb-purchase-tile-price';
          price.textContent = money(variant.price) + ' ex VAT';
          const each = document.createElement('small');
          each.textContent = 'Approx. ' + unit(variant.price, variant.pack) + ' each';
          label.append(count, price, each);
          input.setAttribute('aria-label', 'Pack of ' + variant.pack + ' tubs with lids, ' + money(variant.price) + ' ex VAT per pack, approximately ' + unit(variant.price,variant.pack) + ' ex VAT per set');
        });
      });
      const qtyLabel = form.querySelector('quantity-input label, .quantity-input label, label[for^="quantity-"]');
      if (qtyLabel) {
        qtyLabel.textContent = 'Quantity (packs)';
        qtyLabel.classList.remove('visually-hidden');
      }
      const qtyInput = form.querySelector('[name="quantity"]');
      if (qtyInput) qtyInput.setAttribute('aria-label', 'Quantity (packs)');
      let selected = data.variants.find(item => String(item.id) === String(data.selectedId));
      const stock = panel.querySelector('[data-cb-stock]');
      function inStock() { return selected && selected.available && selected.tracked && selected.stock > 0; }
      function updateDelivery() {
        if (!section.isConnected) return;
        const message = inStock() ? window.CBNaturalPurchaseUtils.delivery(new Date()) : {
          headline: selected && selected.available ? 'Contact us to confirm delivery timing' : 'This pack is currently out of stock',
          detail: selected && selected.available ? 'Delivery dates depend on stock availability.' : 'Choose another pack size or contact our team.', estimate:''
        };
        panel.querySelector('[data-cb-delivery-heading]').textContent = message.headline;
        panel.querySelector('[data-cb-delivery-detail]').textContent = message.detail;
        panel.querySelector('[data-cb-delivery-estimate]').textContent = message.estimate;
      }
      function updateState(variant) {
        selected = variant;
        const available = selected && selected.available;
        stock.dataset.state = inStock() ? 'stock' : available ? 'order' : 'sold-out';
        stock.querySelector('[data-cb-stock-title]').textContent = inStock() ? 'In stock' : available ? 'Available to order' : 'Out of stock';
        stock.querySelector('[data-cb-stock-detail]').textContent = inStock() ? 'Ready for dispatch' : 'Check availability';
        updateDelivery();
      }
      section.addEventListener('on:variant:change', event => {
        updateState(data.variants.find(item => event.detail.variant && String(item.id) === String(event.detail.variant.id)));
      });
      updateState(selected);
      function tick() {
        if (!section.isConnected) return;
        updateDelivery();
        setTimeout(tick,1000);
      }
      setTimeout(tick,1000);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document), {once:true});
  else initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
